import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import I24CrossFilled from "assets/icons/I24CrossFilled";

import styleConst from "constants/style";

import {
  ButtonContainer,
  Container,
  IconContainer,
  Input,
  SearchButton,
} from "./styles";
import { WithTranslation, withTranslation } from "react-i18next";

type Props = {
  initValue?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  onApply?: (value: string) => void;
  onClear?: () => void;
  className?: any;
  disabled?: boolean;
  customIcon?: React.ReactNode;
  onCustomIconClick?: () => void;
  withoutClearIcon?: boolean;
  onlyNumber?: boolean;
} & WithTranslation;

const Search = observer((props: Props) => {
  const {
    initValue,
    placeholder,
    className,
    disabled,
    withoutClearIcon,
    customIcon,
    onChange,
    onApply,
    onClear,
    onCustomIconClick,
    onlyNumber,
  } = props;

  const t: (key: string) => string = props.t || (key => key);

  const [value, setValue] = useState("");

  const inputRef = useRef<HTMLInputElement>(null);

  const isEmpty = !value;

  useEffect(() => {
    const initialValue = initValue ?? "";
    setValue(initialValue);
  }, [initValue]);

  const blurInput = () => {
    inputRef.current?.blur();
  };

  const handleChange = (newValue: string) => {
    setValue(newValue);
    onChange?.(newValue);
  };

  const apply = () => {
    onApply?.(value);
    blurInput();
  };

  const clear = () => {
    setValue("");
    onClear?.();
    blurInput();
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      apply();
    }
  };

  return (
    <Container className={className}>
      <Input
        value={value}
        onChangeText={handleChange}
        placeholder={placeholder ?? t("actions.search")}
        onKeyDown={onKeyDown}
        disabled={disabled}
        withIcon={!isEmpty}
        numbersOnly={onlyNumber}
        onlyPositiveNumbers={onlyNumber}
      />
      {!!value && !withoutClearIcon && (
        <IconContainer onClick={clear}>
          <I24CrossFilled color={styleConst.colors.black25} />
        </IconContainer>
      )}
      {customIcon && (
        <IconContainer onClick={onCustomIconClick}>{customIcon}</IconContainer>
      )}
      <ButtonContainer>
        <SearchButton text={t("actions.search")} height={50} onClick={apply} />
      </ButtonContainer>
    </Container>
  );
});

export default withTranslation()(Search);
